const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/* Formats an ISO date (YYYY-MM-DD or a full timestamp) the same way on the server and in the browser. */
export const formatDate = (value: string | null): string => {
    if (!value) return ''

    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)

    if (!match) return value

    const month = MONTHS[Number(match[2]) - 1]

    return month ? `${month} ${Number(match[3])}, ${match[1]}` : value
}

export const pad = (value: number): string => String(value).padStart(2, '0')
